/** Site-wide video assets in /public/videos/ */
export const SITE_VIDEOS = {
  /** 4:5 — hamburger menu panel */
  menu: '/videos/menu.mp4',
  /** 16:9 — homepage reel (replace when export is ready) */
  homeReel: '/videos/home-reel.mp4',
};
